(function () {
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const article = document.querySelector('.article__content, .article-content, .rte, article .rte');
    if (!article) return;

    // Find the <!-- toc --> placeholder comment inside the article
    const placeholder = findCommentNode(article, 'toc');
    if (!placeholder) return; // no marker, no TOC

    const headings = Array.from(article.querySelectorAll('h2, h3'))
      .filter((h) => !h.closest('.toc-wrapper'));
    if (headings.length < 2) {
      placeholder.remove();
      return;
    }

    const usedIds = new Set();
    const list = document.createElement('ul');
    list.className = 'toc-list';
    let currentSublist = null;

    headings.forEach((heading) => {
      if (!heading.id) heading.id = uniqueSlug(heading.textContent, usedIds);
      usedIds.add(heading.id);

      const li = document.createElement('li');
      li.className = `toc-item toc-${heading.tagName.toLowerCase()}`;
      const a = document.createElement('a');
      a.href = `#${heading.id}`;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);

      if (heading.tagName === 'H2') {
        list.appendChild(li);
        currentSublist = null;
      } else {
        const lastH2 = list.lastElementChild;
        if (lastH2) {
          if (!currentSublist) {
            currentSublist = document.createElement('ul');
            currentSublist.className = 'toc-sublist';
            lastH2.appendChild(currentSublist);
          }
          currentSublist.appendChild(li);
        } else {
          list.appendChild(li);
        }
      }
    });

    // Build the wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'toc-wrapper';
    wrapper.innerHTML = '<p class="toc-title">Table of Contents</p>';
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Table of contents');
    nav.appendChild(list);
    wrapper.appendChild(nav);

    // Replace the comment with the TOC
    placeholder.parentNode.replaceChild(wrapper, placeholder);
  }

  function findCommentNode(root, text) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_COMMENT, null);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim().toLowerCase() === text) return node;
    }
    return null;
  }

  function uniqueSlug(text, used) {
    const base = text.trim().toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
    let slug = base;
    let n = 2;
    while (used.has(slug)) slug = `${base}-${n++}`;
    return slug;
  }
})();